import { mount, unmount } from 'svelte';
import ConfirmModal from './ConfirmModal.svelte';

export type ConfirmModalOptions = {
  labels?: {
    confirm?: string;
    cancel?: string;
    title?: string;
  };
  type?: 'success' | 'error' | 'warning' | 'info';
  classes?: {
    confirm?: string;
    cancel?: string;
    backdrop?: string;
    positioner?: string;
    content?: string;
  };
};

export function confirmModal(
  message: string,
  onConfirm?: () => void | Promise<void>,
  onCancel?: () => void,
  options: ConfirmModalOptions = {}
): void {
  const target = document.createElement('div');
  document.body.appendChild(target);

  let component: ReturnType<typeof ConfirmModal>;

  const cleanup = () => {
    unmount(component);
    target.remove();
  };

  component = mount(ConfirmModal, {
    target,
    props: {
      open: true,
      message,
      onConfirm: async () => {
        cleanup();
        await onConfirm?.();
      },
      onCancel: () => {
        onCancel?.();
        cleanup();
      },
      labels: {
        confirm: 'Bekreft',
        cancel: 'Avbryt',
        title: 'Bekreft handling',
        ...(options.labels ?? {})
      },
      type: options.type ?? 'success',
      classes: {
        backdrop: 'fixed inset-0 bg-secondary/50',
        positioner: 'fixed inset-0 z-50 flex justify-center items-center p-4',
        content: 'bg-white w-[640px] max-w-full rounded-sm p-6',
        ...(options.classes ?? {})
      }
    }
  });
}